module.exports = __webpack_public_path__ + "static/media/stripe-logo.cc80ab70.png";